import React from 'react';
import './css/Header.css';

class MenuMovil extends React.Component {
  constructor(props) {
    super(props);
    this.state={}
  }

  clickHandler(e, url){
    e.preventDefault();
    this.props.cerrarMenu();
    this.props.history.push(url);
  }

  cerrarSesion(){
    sessionStorage.clear();
    this.props.cerrarMenu();
    this.props.history.push('/');
  }

  menuDerecha(){
    const token = sessionStorage.getItem('token');
    if (token) {
      return(
        <>
          <span
            style={{
              color:'white', fontSize:22, marginBottom:13,
              textDecoration:'none',cursor:'pointer'
            }}
            onClick={(e)=>this.clickHandler(e, "/telegram")}
          >
            Telegram
          </span>
          <span
            style={{
              color:'white', fontSize:22, marginBottom:13,
              textDecoration:'none',cursor:'pointer'
            }}
            onClick={()=>this.cerrarSesion()}
          >
            Cerrar Sesión
          </span>
        </>
      )
    } else {
      return(
        <a
          style={{
            color:'white', fontSize:22, marginBottom:13,
            textDecoration:'none'
          }}
          href="/login"
          onClick={(e)=>this.clickHandler(e, "/login")}
        >
          Ingresar
        </a>
      )
    }
  }

  render(){
    const {menuIzq} = this.props;
    return(
      <div
        style={{
          position:'absolute', display:'flex', flexDirection:'column',
          zIndex:5, width:'80%', backgroundColor:'#00a6e5',
          top:105, right:0, padding:10, borderTopLeftRadius:8, borderBottomLeftRadius:8,
          justifyContent:'center', alignItems:'center'
        }}
      >
        {menuIzq.map((item,index) => {
          return(
            <a
              style={{
                color:'white', fontSize:22, marginBottom:13,
                textDecoration:'none'
              }}
              href={item.url}
              key={index}
              onClick={(e)=>this.clickHandler(e, item.url)}
            >
              {item.titulo}
            </a>
          )
        })}
        <hr width='90%'/>
        {this.menuDerecha()}
      </div>
    );
  }
}

export default MenuMovil;
